import React, {createContext, useState} from 'react';
import LoadingModal from '../components/modules/LoadingModal';

export const loadingPauseContext = createContext();
const {Provider} = loadingPauseContext;

const LoadingPauseContext = props => {
  const [visible, setVisible] = useState(false);

  const setVisibleWithTimeout = visiblilty => {
    setTimeout(() => {
      setVisible(visiblilty);
    }, 100); //reduced the timeout hoping no more blocks! maybe we can remove in future if all goes well.
  };

  const closeLoader = () => {
    setVisible(false);
  };

  return (
    <>
      <Provider
        value={{
          visible,
          setVisible,
          setVisibleWithTimeout,
        }}>
        <>
          {props.children}
          {visible && <LoadingModal closeLoader={closeLoader} />}
        </>
      </Provider>
    </>
  );
};

export default LoadingPauseContext;
